<template>
  <div class="login">
    <h3>Admin Zugang</h3>
    <div>
      <input type="text" v-model="email" placeholder="Email" autocomplete="maxkadeemail"><br>
      <input type="password" v-model="password" placeholder="Password" autocomplete="maxkadepass"><br>
      <button v-on:click="signIn">Login</button>
    </div>
    <!--<p>Noch keinen Account? Erstelle <router-link to="/sign-up">einen</router-link></p>-->
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'AdminLogin',
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signIn: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.push('/maingallery')
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      )
    }
  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
  .login {
    margin-top: 40px;
  }

  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminLogin.vue